import { render, staticRenderFns } from "./CheckboxTextBuilder.vue?vue&type=template&id=11f76d36&scoped=true"
import script from "./CheckboxTextBuilder.vue?vue&type=script&lang=js"
export * from "./CheckboxTextBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f76d36",
  null
  
)

export default component.exports